module.exports = __webpack_public_path__ + "img/kyxl.006c2d15.jpg";